import React from "react";
import { useTranslation } from "react-i18next";

/** Sélecteur Mensuel | Annuel -20 % — instantané, sans rechargement. */
export function BillingToggle({ interval, onChange, testid = "billing-toggle" }) {
  const { t } = useTranslation();
  const base = "rounded-full px-5 py-2 text-xs font-bold transition-all duration-200";
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-secondary/50 p-1" data-testid={testid}>
      <button type="button" onClick={() => onChange("month")} data-testid="billing-toggle-month"
        className={`${base} ${interval === "month" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>
        {t("pricing.monthly")}
      </button>
      <button type="button" onClick={() => onChange("year")} data-testid="billing-toggle-year"
        className={`${base} flex items-center gap-1.5 ${interval === "year" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>
        {t("pricing.yearly")}
        <span className="rounded-full bg-success/15 text-success text-[10px] font-black px-2 py-0.5">{t("pricing.yearlyDiscount")}</span>
      </button>
    </div>
  );
}

/** Prix d'une offre selon la périodicité — annuel : équivalent mensuel mis en avant,
 * avec mention explicite du montant annuel facturé en une seule fois. */
export function PlanPrice({ priceMonth, priceYear, interval }) {
  const { t, i18n } = useTranslation();
  const fmt = (v) => new Intl.NumberFormat(i18n.language, { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
  if (interval === "year") {
    return (
      <div className="mb-6">
        <div className="flex items-baseline gap-1.5">
          <span className="font-display text-4xl font-extrabold tracking-tight">{fmt(priceYear / 12)} €</span>
          <span className="text-sm text-muted-foreground">{t("pricing.perMonth")}</span>
        </div>
        <p className="text-xs text-muted-foreground mt-1" data-testid="billed-annually">
          {t("pricing.billedAnnually", { amount: `${fmt(priceYear)} €` })}
        </p>
        <span className="inline-block mt-2 rounded-full bg-success/15 text-success text-[10px] font-black px-2.5 py-1" data-testid="save20-badge">
          {t("pricing.save20")}
        </span>
      </div>
    );
  }
  return (
    <div className="mb-6">
      <div className="flex items-baseline gap-1.5">
        <span className="font-display text-4xl font-extrabold tracking-tight">{fmt(priceMonth)} €</span>
        <span className="text-sm text-muted-foreground">{t("pricing.perMonth")}</span>
      </div>
    </div>
  );
}
